export const environment = {
  production: false,
  companyName: "Wideverse",
  title: 'Scotty Expert',
  showByWideverseWatermark: true,
  frontendUrl: 'https://scotty-expert-dev.web.app',
  faviconUrl: 'favicon.ico',
  resourceManager: {
    endpoint: 'https://dev.tilly-storage.scotty.expert',
    bucket: 'scotty-expert-dev.appspot.com',
  },
  videocall: {
    productName: "Scotty Mobile AR",
    productVersion: "0.1",
    webrtcBrokerEndpoint: 'https://dev.livekit-api.scotty.expert',
    webrtcBrokerSignaller: 'wss://scotty.livekit.cloud',
    bucket: 'scotty-expert-dev.appspot.com',
  },
  firebaseConfig: {
    apiKey: "AIzaSyALWgPZMC2Vm8XCNmDRSsaz9tDZ1-j_H8Y",
    authDomain: "scotty-expert-dev.firebaseapp.com",
    databaseURL: "https://scotty-expert-dev.firebaseio.com",
    projectId: "scotty-expert-dev",
    storageBucket: "scotty-expert-dev.appspot.com",
    messagingSenderId: "259379011565",
    appId: "1:259379011565:web:761ad747b0723f055ed1e4",
    measurementId: "G-VQS3QX3VYT"
  },
  apiEndpoint: 'https://europe-west3-scotty-expert-dev.cloudfunctions.net',
  firebaseMessagingKey: 'AAAAPGQxn-0:APA91bG9adu-uO5xbdCHywQ-4nQrGoArPjHKXx-FVHFbCfhhCwLp1MmTBDKWoec9UiLNRguTnClS3FzIiB4IyLTV6BI7ixNy3v3yW6QimCRkouZSkGOnEuYoEOzq_DXd0NTC5335fb_6',
  /* Messaggi per notifiche */
  notifications: {
    fcmTokensNode: 'web_notifcation_fcm/', // nodo firebase dove vengono storati i token FCM
    measurement: {
      title: 'Misuarazione fuori soglia',
      body: 'Rilevata una misurazione fuori soglia'
    },
    tickets: {
      title: 'Nuova richiesta di assistenza',
      body: 'Hai ricevuto una nuova richiesta di assistenza'
    }
  },
  storage: {  /* base path firebase per chat ed immagini */
    chatFilePath: 'chat/{0}/100/',
    deviceImageFilePath: 'device/images/'
  },
  dateFormat: 'DD/MM/YYYY',
  adminRole: 'admin',   /* strigna che indica il ruolo amminstratore */
  messages: {
    noConnection: 'Nessuna connessione',
    deleteConfirm: 'Vuoi confermare l\'eliminazione',
    editTitle: 'Modifica',
    addTitle: 'Aggiungi',
    detailTitle: 'Dettaglio',
    patient: 'Paziente',
    worker: 'Operatore',
    domicile_worker: 'Operatore domiciliare',
    device: 'Dispositivo',
    measureType: 'Tipologia misurazione',
  },
  defaultDateLocale: 'it-IT',
  privacy: {
    endpoint: 'https://www.iubenda.com/api/privacy-policy/34576083',
  },
  showPrivacyPolicy: true,
  restApi: {
    endpoint: 'https://dev.api.scotty.expert/api',
    infoEndpoint: 'https://dev.api.scotty.expert/api-info',
  },
  reactiveApi: {
    endpoint: 'https://dev.reactive-api.scotty.expert',
  },
  tilly: {
    endpoint: 'https://dev.tilly.scotty.expert/tilly-chat-server/api',
  },
  recorder: {
    enableTracking: false,
    userKeepAliveInterval: 20, // In seconds
    endpoint:  'https://track-test.ddns.net/api', // 'https://dev.track.scotty.expert/api'
  },
  loginUrl: '/login',
  ssoDomain: null, // Configure if needed
  authProvider: 'firebase', // 'firebase' | 'parse' | 'keycloak'
  keycloak: {
    baseEndpoint: null,
    realm: null,
    tokenEndpoint: null,
    userInfoEndpoint: null,
    revocationEndpoint: null,
    clientId: null,
    redirectUri: null,
    responseType: null,
    scope: null,
    requireHttps: null,
    showDebugInformation: null,
    disableAtHashCheck: null
  },
  parse: {
    useParse: false,
    appId: 'scotty-expert',
    serverURL: 'https://parse.scotty-expert.localdomain/parse',
    liveQueryServerURL: 'wss://parse.scotty-expert.localdomain/',
    javascriptKey: 'SuO0CvhwpI'
  },
  rebrand: {
    showFullLogo: true,
    logoExtension: 'svg',
    brand: 'scotty-expert'
  },
  features: {
    fieldManagerManagement: false,
    recommenderEngine: false,
  }
};
